// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Blob, BlobT, verifyBlob } from "./blob";
import { IdlOptions, IdlOptionsT, verifyIdlOptions } from "./idl-options";

/**
 * Inflate one blob for display.
 */
export class InflateRequest implements flatbuffers.IUnpackableObject<InflateRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): InflateRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsInflateRequest(bb: flatbuffers.ByteBuffer, obj?: InflateRequest): InflateRequest {
    return (obj || new InflateRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsInflateRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: InflateRequest,
  ): InflateRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new InflateRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  blob(obj?: Blob): Blob | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Blob()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  options(obj?: IdlOptions): IdlOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startInflateRequest(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addBlob(builder: flatbuffers.Builder, blobOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, blobOffset, 0);
  }

  static addOptions(builder: flatbuffers.Builder, optionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, optionsOffset, 0);
  }

  static endInflateRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // blob
    return offset;
  }

  unpack(): InflateRequestT {
    return new InflateRequestT(
      this.blob() !== null ? this.blob()!.unpack() : null,
      this.options() !== null ? this.options()!.unpack() : null,
    );
  }

  unpackTo(_o: InflateRequestT): void {
    _o.blob = this.blob() !== null ? this.blob()!.unpack() : null;
    _o.options = this.options() !== null ? this.options()!.unpack() : null;
  }

  unpackFields(...fields: string[]): InflateRequestT {
    const t = new InflateRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("blob")) {
      t.blob = this.blob() !== null ? this.blob()!.unpack() : null;
    }
    if (fieldSet.has("options")) {
      t.options = this.options() !== null ? this.options()!.unpack() : null;
    }
    return t;
  }
}

export class InflateRequestT implements flatbuffers.IGeneratedObject {
  constructor(
    public blob: BlobT | null = null,
    public options: IdlOptionsT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.blob === null || this.blob === undefined) {
      throw new Error('Required field "blob" is not set');
    }
    const blob = this.blob !== null ? this.blob!.pack(builder) : 0;
    const options = this.options !== null ? this.options!.pack(builder) : 0;

    InflateRequest.startInflateRequest(builder);
    InflateRequest.addBlob(builder, blob);
    InflateRequest.addOptions(builder, options);

    return InflateRequest.endInflateRequest(builder);
  }

  clone(): InflateRequestT {
    const obj = new InflateRequestT();
    obj.blob = this.blob !== null ? this.blob!.clone() : null;
    obj.options = this.options !== null ? this.options!.clone() : null;
    return obj;
  }

  equals(other: InflateRequestT): boolean {
    if (this.blob !== null && other.blob !== null) {
      if (!this.blob!.equals(other.blob!)) return false;
    } else if (this.blob !== other.blob) return false;
    if (this.options !== null && other.options !== null) {
      if (!this.options!.equals(other.options!)) return false;
    } else if (this.options !== other.options) return false;
    return true;
  }
}

export function verifyInflateRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBlob(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "blob");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlOptions(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
